<template>
  <div class="progress-circle" :class="[graphData.class]">
    <div class="barOverflow">
      <div class="bar">

      </div>
    </div>
    <div class="progress-pin"></div>
    <div class="progress-label" :title="progress">
      {{ graphData.label }}
      <div class="progress-subtitle">
        {{ graphData.subtitle }}
      </div>
    </div>

  </div>
</template>

<script>
/*
Concept stage: haven’t started developing the product.
 In development: The product is not usable yet.
 First product ready, but no users yet.
 Product launched with at least one free user.
 Revenue stage, at least one paying user.
 Revenue generating for at least the past 2 years.
 */
let STAGES = {
  "A1": {
    "label": "Concept stage",
    "subtitle": "haven't started developing the product.",
    "class": "bar-25"
  },
  "A2": {
    "label": "Development",
    "subtitle": "The product is not usable yet.",
    "class": "bar-50"
  },
  "A3": {
    "label": "First product ready",
    "subtitle": "but no users yet.",
    "class": "bar-60"
  },
  "A4": {
    "label": "Product launched",
    "subtitle": "with at least one free user.",
    "class": "bar-75"
  },
  "A5": {
    "label": "Revenue stage",
    "subtitle": "at least one paying user.",
    "class": "bar-85"
  },
  "A6": {
    "label": "Generating Revenue",
    "subtitle": "for at least the past 2 years.",
    "class": "bar-100"
  },
}

export default {
  name: 'stageGraph',
  data() {
    return {
      graphData: STAGES[this.progress],
    }
  },
  props: ['progress'],
  mounted() {
  },
  methods: {},
  computed: {},
}
</script>

<style lang="scss" scoped>

.progress-circle {
  position: relative;
}

.barOverflow {
  margin: auto;
  position: relative;
  overflow: hidden;
  width: 240px;
  height: 110px;
}

.bar-25 {
  .bar {
    transform: rotate(-275deg);
  }

  .progress-pin {
    left: 41%;
    transform: rotate(-69deg);
  }
}

.bar-50 {
  .bar {
    transform: rotate(-220deg);
  }

  .progress-pin {
    transform: rotate(7deg);
  }
}

.bar-60 {

  .bar {
    transform: rotate(-200deg);
  }

  .progress-pin {
    transform: rotate(35deg);
  }
}

.bar-75 {

  .bar {
    transform: rotate(-190deg);
  }

  .progress-pin {
    transform: rotate(43deg);
  }
}

.bar-85 {
  .bar {
    transform: rotate(-160deg);
  }

  .progress-pin {
    transform: rotate(90deg);
  }
}

.bar-100 {
  .bar {
    transform: rotate(-130deg);
  }

  .progress-pin {
    transform: rotate(103deg);
  }
}

.bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 240px;
  height: 240px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 24px solid #E2E9EA;
  border-bottom-color: #FC4F26;
  border-right-color: #FC4F26;
  transform: rotate(0deg);
  transition: all 1s;


}

.progress-pin {
  transition: all 1s;
  position: absolute;
  left: 40%;
  top: 39px;
  height: 50px;
  width: 50px;
  background-image: url(../../../images/icons/stage.svg);
  transform: rotate(0deg);
  transform-origin: center 40px;
}

.progress-label {
  font-weight: bold;
  text-align: center;
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 100%;
}

.progress-subtitle {
  font-size: 11px;
  color: #999;
  font-weight: 300;
  width: 80%;
  margin: auto
}
</style>
